// src/App.js

import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import Leaderboard from './components/Leaderboard';
import LeaderboardWrapper from './components/LeaderBoardWrapper'

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/:campaignID" element={<LeaderboardWrapper />} />
    </Routes>
  );
}

export default App;
